export default "__VITE_ASSET__c926b3ff__"